import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

export const load = (() => {
	return {
		pagename: routesPagename.PROFILE_AUTHENTIFICATION,
	};
}) satisfies PageLoad;
